import React from 'react';
import useStyles from './styles';

interface Props {
  Body: React.CElement<any, any>;
  Icon: React.ComponentType<any>;
}

const SelectOrganizationText = ({ Body, Icon }: Props) => {
  const styles = useStyles();
  return (
    <div className={styles.container}>
      <div className={styles.iconContainer}>
        <Icon className={styles.icon} />
      </div>
      {Body}
    </div>
  );
};

SelectOrganizationText.propTypes = {};

export default SelectOrganizationText;
